module.exports = __webpack_public_path__ + "static/media/apple_icon.0dd15a13.svg";